// Acompanhamento — sem retorno (cortes) + oportunidades (API real).
import AXIOS from "@/services/axios";
import { initialsOf, avatarClassFor } from "./helpers";

function adaptPatient(p, i) {
  return {
    id: p.id,
    name: p.name,
    initials: initialsOf(p.name),
    avatarClass: avatarClassFor(i),
    phone: p.phone_number,
    doctorName: p.doctor_name,
    specialty: p.specialty || "",
    lastAppointment: p.last_appointment_at,
    daysSinceLast: p.days_since_last
  };
}

export class ClinicFollowup {
  /** Pacientes cujo último atendimento excede o corte (30/60/90 dias). */
  static noReturn(params = {}) {
    const cutoff = Number(params.cutoff) || 30;
    return AXIOS.get(`clinica/no-return?cutoff=${cutoff}`).then(res => ({
      data: {
        items: (res.data.items || []).map(adaptPatient),
        counts: res.data.counts || {}
      }
    }));
  }

  /** Oportunidades: grupos agregados + lista priorizada (grupo Retorno,
   *  ranqueada por potencial = ticket histórico do paciente). */
  static opportunities() {
    return AXIOS.get("clinica/opportunities").then(({ data }) => ({
      data: {
        groups: (data.groups || []).map(g => ({
          id: g.id,
          label: g.label,
          count: g.count,
          description: g.description,
          tagVariant: g.tag_variant
        })),
        items: (data.items || []).map((it, i) => ({
          patientId: it.patient_id,
          name: it.name,
          initials: initialsOf(it.name),
          av: avatarClassFor(i),
          type: "Retorno",
          typeVariant: "info",
          reason: `Sem retorno há ${it.days_since_last} dias`,
          potential: it.potential_cents
        }))
      }
    }));
  }
}

export default ClinicFollowup;
